import React from "react";

import type { FilterModalProps } from "./FilterModalProps";
import SaveFilter from "./SaveFilter";
import ViewFilters from "./ViewFilters";
import Modal from "../../Modal/Modal";

const SaveFilterModal = (props: FilterModalProps) => {
  const { isOpened, close } = props;

  return (
    <Modal
      isOpened={!!isOpened}
      title={isOpened === "newFilter" ? "Save as View" : "Saved Views"}
      toggle={close}
      focusTrap={false}
      style={
        isOpened === "newFilter"
          ? undefined
          : { maxWidth: "min(1200px, calc(100% - 60px))" }
      }
    >
      {isOpened === "newFilter" ? (
        <SaveFilter {...props} />
      ) : (
        <ViewFilters {...props} />
      )}
    </Modal>
  );
};

export default SaveFilterModal;
